import type { RutaProd } from '../../../../runtime/rutas';
export default {
  ruta: '/sistema/punto-de-venta/configuraciones/productos',
  documento: 'pos-settings',
  acceso: 'sesion',
  filas: ['018'],
  cita: 'Areas/POS_Settings/Controllers/SettingsController.cs:123',
} satisfies RutaProd;
